<template>
  <hm-content title="预约活动发券列表" ref="hmcontent">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addActivity"
          >新增多功能二维码</el-button
        >
        <el-button type="success" size="small" @click="output"
          >导出导购邀请注册二维码</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="keyword"
          placeholder="输入关键词"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        ref="table"
        stripe
        border
        :data="records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          label="序号"
          type="index"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="applicationScenario"
          label="应用场景"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.applicationScenario === 'invite_register'">
              邀请注册
            </div>
            <div v-else>
              {{ scope.row.applicationScenario }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column header-align="center" align="center" label="场景时效">
          <template slot-scope="scope">
            <span>{{
              scope.row.actionName === "QR_SCENE" ? "临时" : "永久"
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="masterName"
          label="关联人员"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="scanFunction"
          label="功能"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.scanFunction === 'coupon'">
              优惠券
            </div>
            <div v-else-if="scope.row.scanFunction === 'subscribeActivity'">
              预约活动
            </div>
            <div v-else-if="scope.row.scanFunction === 'invite'">
              邀请注册
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="scanCount"
          label="扫描量"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="registerScanCount"
          label="扫描注册人数"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                class="primary"
                size="small"
                type="text"
                @click="viewQr(scope.row)"
                >二维码</el-button
              >
              <el-button
                class="primary"
                size="small"
                type="text"
                v-if="scope.row.scanFunction !== 'invite'"
                @click="details(scope.row)"
                >详情</el-button
              >
              <!-- <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer mr10" @click="viewQr(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip> -->
              <!-- <el-tooltip class="item" content="编辑" placement="top">
                <div
                  class="pointer mr10"
                  @click="edit(scope.row)"
                  v-show="scope.row.auditState !== 'audit_pass'"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div
                  class="pointer"
                  @click="remove(scope.row)"
                  v-show="
                    scope.row.auditState !== 'audit_pass' ||
                      (scope.row.auditState === 'audit_pass' &&
                        scope.row.actStatus === 'disabled')
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @size-change="handleSizeChange"
        @current-change="paging"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>

    <el-dialog
      title="查看多功能二维码"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      width="1000px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="场景名称">
          <div>
            {{ detailsInfo.applicationScenario }}
          </div>
        </el-form-item>
        <el-form-item label="二维码类型">
          <div>
            {{ detailsInfo.scanFunction === "coupon" ? "优惠券" : "预约活动" }}
          </div>
        </el-form-item>
        <template v-if="detailsInfo.scanFunction === 'coupon'">
          <el-form-item label="优惠券类型">
            {{ detailsInfo.couponMode === "all" ? "全部优惠券" : "指定优惠券" }}
            <div v-if="detailsInfo.couponMode === 'appoint'">
              <el-table
                stripe
                border
                :data="detailsInfo.couponModelList"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="wxshopSpuName"
                  label="使用对象"
                >
                  <template slot-scope="scope">
                    <div>
                      {{
                        scope.row.isPlus === 0
                          ? "PLUS会员"
                          : scope.row.isPlus === "1"
                          ? "全部会员"
                          : "全部会员"
                      }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="name"
                  label="优惠券名称"
                >
                </el-table-column>
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  prop="labelName"
                  label="标签"
                >
                </el-table-column> -->
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="levelMin"
                  label="使用门槛"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="wxshopSpuName"
                  label="活动时间"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.ruleStartDate }}至{{ scope.row.ruleEndDate }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </template>
        <template v-else-if="detailsInfo.scanFunction === 'subscribeActivity'">
          <el-form-item label="预约活动">
            <el-table
              stripe
              ref="table"
              :data="[detailsInfo.activityVo]"
              style="width: 100%"
              id="table"
              size="small"
              border
            >
              <el-table-column
                header-align="center"
                prop="actName"
                align="center"
                label="活动名称"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="活动状态"
              >
                <template slot-scope="scope">
                  <div class="item-center">
                    <span
                      class="success"
                      v-if="scope.row.timeStatus === 'running'"
                      >进行中</span
                    >
                    <span
                      class="gray"
                      v-else-if="scope.row.timeStatus === 'notStart'"
                      >未开始</span
                    >
                    <span
                      class="danger"
                      v-else-if="scope.row.timeStatus === 'end'"
                      >已结束</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                width="240px"
                prop="date"
                label="活动日期"
              >
                <template slot-scope="scope">
                  {{ scope.row.actStartTime }}至{{ scope.row.actEndTime }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="actSite"
                label="地点"
              >
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>
      </el-form>
      <div class="flex flex-center" slot="footer">
        <el-button size="small" @click="dialogFormVisible = false" type="info"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="二维码" width="30%" :visible.sync="qrCodedialogVisible">
      <div>
        <div>
          {{ currentRow.masterName }}
          <span v-if="currentRow.applicationScenario === 'invite_register'">
            邀请注册
          </span>
          <span v-else>
            {{ currentRow.applicationScenario }}
          </span>
        </div>
      </div>
      <div class="text-center">
        <img :src="qrPath" alt="" style="width: 200px" />
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="qrCodedialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import {getLoginUser, getUserName} from "@/utils/auth";
export default {
  data() {
    return {
      detailsInfo: {},
      records: [],
      total: 0,
      applyDate: [],
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      pageSize: 10,
      date: [],
      qrPath: "",
      qrCodedialogVisible: false,
      keyword: "",
      promotionCode: "",
      actName: "",
      mode: "",
      currentRowId: "",
      actStatus: "",
      auditState: "",
      dialogFormVisible: false,
      keywordList: [],
      currentRow: {},
      ruleForm: {
        scene: "",
        actionName: "QR_SCENE",
        keyword: []
      },
      rules: {
        scene: [
          {
            required: true,
            message: "请输入场景名",
            trigger: "change"
          },
          {
            max: 15,
            message: "场景名不能大于15个字符",
            trigger: "change"
          }
        ],
        keyword: [
          {
            required: true,
            message: "请选择关键词",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    this.queryList();
  },
  watch: {},
  methods: {
    async output() {
      await this.$store.dispatch("exportStoreMiniprogScan");
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    async details(row) {
      const { result } = await this.$store.dispatch(
        "queryStoreMiniprogramScan",
        {
          scanId: row.scanId
        }
      );

      this.detailsInfo = result;
      this.dialogFormVisible = true;
    },
    async viewQr(row) {
      let params = {};

      if (row.scanFunction === "invite") {
        await this.saveSharePathNew(
          `inviteCenterId=${row.masterId}&workNum=${row.workNum}`
        );
        params = {
          path: "pages/loading/loading?saveUUID=" + this.saveUUID,
          authorizerAppid: row.authorizerAppid
        };
      } else if (
        row.scanFunction === "coupon" ||
        row.scanFunction === "subscribeActivity"
      ) {
        await this.saveSharePathNew("masterId=" + row.masterId);
        params = {
          path: "customization/writeOff?saveUUID=" + this.saveUUID,
          authorizerAppid: row.authorizerAppid
        };
      }

      const { result } = await this.$store.dispatch(
        "queryCurrentQrcode",
        params
      );
      this.currentRow = row;
      this.qrCodedialogVisible = true;
      this.qrPath = result;
    },
    async saveSharePathNew(sharePath) {
      if (!sharePath) {
        return;
      }
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: sharePath,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "公众号管理-多功能二维码列表",
        shareFrom: "bg"
      }
      const { result } = await this.$store.dispatch("shareDataSaveV2", params);
      // console.log("saveUUID: ", saveUUID);
      this.saveUUID = result;
    },
    addActivity() {
      // this.dialogFormVisible = true;
      // this.mode = "add";
      // this.queryKeywordList();
      this.$router.push({
        name: "NewQRCode"
      });
    },
    async edit(row) {
      this.dialogFormVisible = true;
      this.currentRowId = row.wxQrId;
      this.mode = "edit";
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
      this.queryKeywordList();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.mode === "add") {
            this.$store.dispatch("addQrcode", this.ruleForm).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.queryList();
              }
            });
          } else {
            const params = Object.assign(this.ruleForm, {
              wxQrId: this.currentRowId
            });
            this.$store.dispatch("editQrcode", params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.queryList();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
      this.dialogFormVisible = false;
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("removeQrcode", {
            wxQrId: row.wxQrId
          })
          .then(res => {
            if (res.code === 0) {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryQrcodeList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        keyword: this.keyword
      });
      const { records, total } = result;
      this.records = records;
      this.total = total;
    },
    async queryKeywordList() {
      const { result } = await this.$store.dispatch("queryKeywordList");
      this.keywordList = result;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}
</style>
